import { useMutation, useQueryClient } from "@tanstack/react-query";

import { patchFarmDocumentScanField } from "services";

import { GET_DOC_SCAN_FIELDS, GET_FARM_DOC_SCAN_FIELD, GET_FARM_DOC_SCAN_FIELDS, PATCH_DOC_SCAN_FIELD } from "consts";

type DocScanFieldReview = { scanId: string; isCorrect: boolean | null; comment: string | null };

export const useUpdateDocScanFieldReview = ({ farmId, scanFieldId }: { farmId: string; scanFieldId: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [PATCH_DOC_SCAN_FIELD, scanFieldId],
    mutationFn: ({ scanId, isCorrect, comment }: DocScanFieldReview) => patchFarmDocumentScanField({ scanId, fieldId: scanFieldId, isCorrect, comment }),
    onSuccess: (_record, { scanId }) =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_FARM_DOC_SCAN_FIELD, farmId, scanFieldId] }),
        queryClient.invalidateQueries({ queryKey: [GET_DOC_SCAN_FIELDS, scanId] }),
        queryClient.invalidateQueries({ queryKey: [GET_FARM_DOC_SCAN_FIELDS, farmId] }),
      ]),
  });
};
